import { apiService } from './apiService'

export interface BasicSettings {
  appName: string
  appVersion: string
  companyName: string
  contactPhone: string
  contactEmail: string
  logoUrl?: string
  icpNumber?: string
  psbNumber?: string
  servicePhone?: string
  serviceHours?: string
}

export interface OperationArea {
  id: string
  province: string
  city: string
}

export interface NotificationSettings {
  newOrder: boolean
  farmerVerify: boolean
  contentVerify: boolean
  orderException: boolean
}

export interface SecuritySettings {
  loginDuration: string
  twoFactorAuth: boolean
  operationLog: boolean
}

export interface MaintenanceSettings {
  cacheSize: string
  lastBackupTime: string
  maintenanceMode: boolean
}

export interface VersionInfo {
  current: string
  hasUpdate: boolean
}

export interface SystemSettings {
  basicSettings: BasicSettings
  notification: NotificationSettings
  security: SecuritySettings
  maintenance: MaintenanceSettings
  version: VersionInfo
}

export const settingsService = {
  // 获取系统设置
  async getSettings(): Promise<SystemSettings> {
    return await apiService.get('/settings')
  },

  // 更新系统设置
  async updateSettings(settings: Partial<SystemSettings>): Promise<SystemSettings> {
    return await apiService.put('/settings', settings)
  },

  // 获取运营范围
  async getOperationAreas(): Promise<OperationArea[]> {
    return await apiService.get('/settings/operation-areas')
  },

  // 添加运营范围
  async addOperationArea(province: string, city: string): Promise<OperationArea> {
    return await apiService.post('/settings/operation-areas', {
      province,
      city
    })
  },

  // 删除运营范围
  async deleteOperationArea(id: string): Promise<void> {
    await apiService.delete(`/settings/operation-areas/${id}`)
  },

  // 系统维护操作
  async maintenanceAction(action: 'clear-cache' | 'backup-data'): Promise<any> {
    return await apiService.post(`/settings/maintenance/${action}`)
  }
}
